/**
 * We want to disable spellcheck for automated tests. We generate a lot of fake
 * data and often times that data was being munged by autocorrect.
 */
if (/(?:^|;)\s*comms-TEST_NAME=[^;]/.test(document.cookie)) {
   for (const field of document.querySelectorAll('textarea, input')) {
      field.setAttribute('spellcheck', 'false');
   }
}
